import { render, staticRenderFns } from "./ProductGrid.vue?vue&type=template&id=294da3bd&scoped=true&"
import script from "./ProductGrid.vue?vue&type=script&lang=ts&"
export * from "./ProductGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGrid.vue?vue&type=style&index=0&id=294da3bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294da3bd",
  null
  
)

export default component.exports